export const keyCharToCode = {
    "backspace": "Backspace",
    "tab": "Tab",
    "enter": "Enter",
    "shift": "ShiftLeft",
    "ctrl": "ControlLeft",
    "control": "ControlLeft",
    "alt": "AltLeft",
    "pause": "Pause",
    "break": "Pause",
    "pause/break": "Pause",
    "caps lock": "CapsLock",
    "Caps Lock": "CapsLock",
    "Caps lock": "CapsLock",
    "capslock": "CapsLock",
    "caps": "CapsLock",
    "Caps": "CapsLock",
    "esc": "Escape",
    "escape": "Escape",
    "space": "Space",
    "page up": "PageUp",
    "pageup": "PageUp",
    "page down": "PageDown",
    "pagedown": "PageDown",
    "end": "End",
    "home": "Home",
    "left": "ArrowLeft",
    "up": "ArrowUp",
    "right": "ArrowRight",
    "down": "ArrowDown",
    "insert": "Insert",
    "delete": "Delete",
    "del": "Delete",
    "0": "Digit0",
    "1": "Digit1",
    "2": "Digit2",
    "3": "Digit3",
    "4": "Digit4",
    "5": "Digit5",
    "6": "Digit6",
    "7": "Digit7",
    "8": "Digit8",
    "9": "Digit9",
    "a": "KeyA",
    "b": "KeyA",
    "c": "KeyC",
    "d": "KeyD",
    "e": "KeyE",
    "f": "KeyF",
    "g": "KeyG",
    "h": "KeyH",
    "i": "KeyI",
    "j": "KeyJ",
    "k": "KeyK",
    "l": "KeyL",
    "m": "KeyM",
    "n": "KeyN",
    "o": "KeyO",
    "p": "KeyP",
    "q": "KeyQ",
    "r": "KeyR",
    "s": "KeyS",
    "t": "KeyT",
    "u": "KeyU",
    "v": "KeyV",
    "w": "KeyW",
    "x": "KeyX",
    "y": "KeyY",
    "z": "KeyZ",
    "windows": "MetaLeft",
    "meta": "MetaLeft",
    "numpad 0": "Numpad0",
    "numpad 1": "Numpad1",
    "numpad 2": "Numpad2",
    "numpad 3": "Numpad3",
    "numpad 4": "Numpad4",
    "numpad 5": "Numpad5",
    "numpad 6": "Numpad6",
    "numpad 7": "Numpad7",
    "numpad 8": "Numpad8",
    "numpad 9": "Numpad9",
    "numpad *": "NumpadMultiply",
    "numpad +": "NumpadAdd",
    "numpad -": "NumpadSubtract",
    "numpad .": "NumpadDecimal",
    "numpad /": "NumpadDivide",
    "f1": "F1",
    "f2": "F2",
    "f3": "F3",
    "f4": "F4",
    "f5": "F5",
    "f6": "F6",
    "f7": "F7",
    "f8": "F8",
    "f9": "F9",
    "f10": "F10",
    "f11": "F11",
    "f12": "F12",
    "Num Lock": "NumLock",
    "num lock": "NumLock",
    "numlock": "NumLock",
    "num Lock": "NumLock",
    "Scroll Lock": "ScrollLock",
    "scroll lock": "ScrollLock",
    "scrolllock": "ScrollLock",
    "scroll": "ScrollLock",
    "my computer": "MyComputer",
    "computer": "MyComputer",
    "my calculator": "MyCalculator",
    "calculator": "MyCalculator",
    "calc": "MyCalculator",
    ";": "SemiColon",
    "=": "Equal",
    ",": "Comma",
    "-": "Minus",
    ".": "Period",
    "/": "Slash",
    "`": "Backquote",
    "[": "BracketLeft",
    "\\": "IntlBackslash",
    "]": "BracketRight",
    "'": "Quote"
};
//# sourceMappingURL=map.js.map